<template>
  <div class="comment-list">
    <div class="comment-list-title">
        <h4>全部评论 <span class="comment-num">{{total}}</span></h4>
    </div>
    <div class="comment-list-content">
        <template v-for="item in commentList">
          <comment-item :key="item.id" :type="type" :comment="item" @refresh="refresh"></comment-item>
          <div v-if="item.children && item.children.length" :key="item.id + 'children'" class="comment-list-content-inner">
            <comment-item v-for="comment in item.children" :key="comment.id" :type="type" :comment="comment" @refresh="refresh"></comment-item>
            <div v-if="item.commentCount > item.children.length" class="showMore" @click="handleSubCommentMore(item)">查看更多<i class="el-icon-arrow-down"></i></div>
          </div>
        </template>
    </div>
    <el-pagination
        background
        layout="prev, pager, next"
        :page-size="queryParam.pageSize"
        :current-page="queryParam.pageNum"
        :total="total"
        hide-on-single-page
        @current-change="handlePageChange">
    </el-pagination>
  </div>
</template>

<script>
import CommentItem from './CommentItem';
import { getCommentList } from '@/api/comment';
const _PAGESIZE = 20;

export default {
  name: 'CommentList',
  components: {
    CommentItem,
  },
  props: {
    type: { // 评论对象类型
      type: Number,
      required: true,
    },
    sourceId: { // 评论对象ID
      type: [Number, String],
      required: true,
    },
    totalNum: { // 评论总条数
      type: Number,
      required: false,
      default: () => 0,
    },
  },
  data: () => ({
    queryParam: {
      commentId: '', // 父级评论ID
      pageNum: 1, 
      pageSize: _PAGESIZE,
      sourceId: '', // 评论对象ID
      sourceType: '', // 评论对象类型
    },
    total: 0, // 总评论数
    commentList: [], // 评论列表
  }),
  watch: {
    'queryParam.pageNum'() {
      this.getCommentList();
    },
  },
  created() {
    this.queryParam.sourceId = this.sourceId;
    this.queryParam.sourceType = this.type;
    this.total = this.totalNum;
    this.getCommentList();
  },
  methods: {
    // 获取评论列表
    getCommentList() {
      getCommentList(this.queryParam).then(data => {
        this.commentList = data.data.map(item => ({
          ...item,
          showMore: item.children && item.children.length > 1
        }));
        this.total = data.extra;
      });
    },
    // 刷新列表
    refresh() {
      this.getCommentList();
    },
    // 改变页码
    handlePageChange(page) {
      this.queryParam.pageNum = page;
    },
    // 楼中楼回复更多
    handleSubCommentMore(comment) {
      const pageNum = Math.ceil(comment.children.length / _PAGESIZE);

      getCommentList({
        commentId: comment.id, 
        pageNum: pageNum, 
        pageSize: _PAGESIZE,
        sourceId: this.sourceId, 
        sourceType: this.type, 
      }).then(data => {
        if (pageNum === 1) {
          this.commentList.find(item => item.id === comment.id).children = data.data;
        } else {
          this.commentList.find(item => item.id === comment.id).children.push(...data.data);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.showMore {
    padding: 10px 0;
    text-align: center;
    cursor: pointer;
}
.el-pagination {
  text-align: center;
  
  /deep/ button, /deep/  .number {
    border-radius: 50% !important;
  }
}
.comment-list {
  color: #333;
  &-title {

  }
  .comment-num {
    color: #999;
    margin-left: 5px;
  }
  &-content {
    margin: 30px 0;
    &-inner {
      margin: 0 0 15px 50px;
      padding: 30px 0 0 30px;
      background-color: #FAFAFA;
      border-radius: 4px;
      overflow: hidden;
    }
  }
}
</style>
